import React, { useEffect } from 'react';

import { Link, withRouter } from 'react-router-dom';

import ReduxConnect from 'Demora/redux-connect';

import modal from 'Demora/modals/modal';

const Announcements = ({ user }) => {
	const announcements = user.announcements;

	const announcementsToShow = [];

	const authShouldntDisplay = (can) => {
		return can !== !!user.id;
	};

	announcements &&
		announcements.map((a, i) => {
			let p = window.location.pathname;

			if (a.auth !== undefined) {
				if (authShouldntDisplay(a.auth)) {
					return;
				}
			}

			if (a.except && a.except.length > 0 && a.except.includes(p)) {
				return;
			}

			if (a.only && a.only.length > 0 && !a.only.includes(p)) {
				return;
			}

			announcementsToShow.push(a);
		});

	useEffect(() => {
		announcementsToShow.map((a, i) => {
			if (a.types && a.types.includes('modal') > -1) {
				const modalId = 'announcements' + a.heading;
				const c = renderAnnouncement(a, i, () => modal.close(modalId));
				modal({
					id: modalId,
					header: a.heading,
					body: c,
				});
			}
		});
	}, []);

	const renderAnnouncement = (a, i, onClick) => {
		const c = (
			<div key={i}>
				<div className={'alert alert-' + a.classContext}>
					{!!a.heading && <h4 className='alert-heading'>{a.heading}</h4>}
					{!!a.content && <div>{a.content}</div>}
					{!!a.footer && !!a.content && <hr className='mt-2 mb-2' />}
					{!!a.footer && <div>{a.footer}</div>}
				</div>
			</div>
		);

		if (!a.link) {
			return c;
		}

		return (
			<Link
				to={a.link}
				key={i}
				style={{ textDecoration: 'none' }}
				onClick={() => onClick && onClick()}
			>
				{c}
			</Link>
		);
	};

	return announcementsToShow.map((a, i) => {
		if (a.types && a.types.includes('announcement') == -1) {
			return null;
		}
		return renderAnnouncement(a, i);
	});
};

export default withRouter(
	ReduxConnect(Announcements, {
		user: 'user',
	})
);
